import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const ImageIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
    className={makeClassName('ImageIcon', className)}
  >
    <path
      d="M19,2H5C3.3,2,2,3.3,2,5v14c0,1.7,1.3,3,3,3h14c1.7,0,3-1.3,3-3V5C22,3.3,20.7,2,19,2z M4,5c0-0.5,0.5-1,1-1h14
	c0.5,0,1,0.5,1,1v7.6l-3.3-3.3c-0.4-0.4-1-0.4-1.4,0L4.7,19.9C4.3,19.8,4,19.4,4,19V5z M20,19c0,0.5-0.5,1-1,1H7.4l8.6-8.6l4,4V19z"
    />
    <path
      d="M8.5,11C7.1,11,6,9.9,6,8.5S7.1,6,8.5,6S11,7.1,11,8.5S9.9,11,8.5,11z M8.5,8C8.2,8,8,8.2,8,8.5S8.2,9,8.5,9S9,8.8,9,8.5
	S8.8,8,8.5,8z"
    />
  </svg>
);

export default ImageIcon;
